import CryptoJS from 'crypto-js';

const secretKey: string = import.meta.env.VITE_PASS_WORD_KEY || '';

export const handleEncrypt = (pw: string) => {
  const encryptedPassword = CryptoJS.AES.encrypt(pw, secretKey).toString();
  return encryptedPassword;
};

export const handleDecrypt = (pw: string) => {
  const bytes = CryptoJS.AES.decrypt(pw, secretKey);
  const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedPassword;
};
